import { render, staticRenderFns } from "./FOLLOW.vue?vue&type=template&id=bdfe1888"
import script from "./FOLLOW.vue?vue&type=script&lang=js"
export * from "./FOLLOW.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports